import React, { PureComponent } from "react";
import { LabelList, ScatterChart, Scatter, XAxis, YAxis, CartesianGrid, Cell, Tooltip } from "recharts";

import styles from "./style.module.css";

export default class WordCountChart extends PureComponent {
  analyzeText(dataArray) {
    const result = {};
    let wordCount = {};
    let totalScore = {};

    dataArray.forEach((data) => {
      const retText = data.userText ?? data.text;
      const feedback_score = data?.feedback?.THUMBS_DOWN?.length * -1 + data?.feedback?.THUMBS_UP?.length;

      let words = retText === undefined ? [] : retText.toLowerCase().split(/\b/);

      words.forEach((word) => {
        word = word.trim();
        if (word !== "" && word.length > 3) {
          if (wordCount[word]) {
            wordCount[word]++;
            totalScore[word] += feedback_score;
          } else {
            wordCount[word] = 1;
            totalScore[word] = feedback_score;
          }
        }
      });
    });

    for (const word in wordCount) {
      result[word] = {
        name: word,
        count: wordCount[word],
        avgFeedbackScore: totalScore[word] / wordCount[word]
      };
    }

    return Object.keys(result)
      .map((r) => result[r])
      .sort((a, b) => b.count - a.count);
    //.filter((a, i) => i < 50);
  }

  render() {
    const { feedback } = this.props;

    const bars = this.analyzeText(feedback);
    const unit = "";
    const label = "count";
    const warning = undefined;

    if (bars === undefined) {
      return <div />;
    }

    let lowX = bars.reduce((min, b) => (parseInt(b[label]) < min ? parseInt(b[label]) : min), 0);

    const CustomTooltip = ({ payload, label, active }) => {
      if (active && payload && payload.length) {
        return (
          <div
            style={{
              backgroundColor: "#f5f5f5",
              border: "1px solid #ccc",
              padding: "10px",
              borderRadius: "5px"
            }}
          >
            <p style={{ margin: 0, fontWeight: "bold", color: "#333" }}>{`Word : ${payload[0]?.payload?.name}`}</p>
            <p style={{ margin: 0 }}>{`Count : ${payload[1].value}`}</p>
            <p style={{ margin: 0 }}>{`Feedback Score : ${payload[0].payload.avgFeedbackScore.toFixed(2)}`}</p>
          </div>
        );
      }

      return null;
    };

    return (
      <div className={styles.scatterChart}>
        <ScatterChart width={440} height={400} margin={{ top: 20, right: 20, bottom: 20, left: 20 }}>
          <CartesianGrid />
          <XAxis dataKey={"avgFeedbackScore"} name="feedback score" unity="" type="number" />
          <YAxis dataKey={"count"} name="count" unit="" type="number" />
          <Tooltip content={<CustomTooltip />} />
          <Scatter name="A school" data={bars} fill="#8884d8">
            <LabelList dataKey="word" position="top" />
            {bars.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.avgFeedbackScore > 0 ? "green" : "red"} />
            ))}
          </Scatter>
        </ScatterChart>
      </div>
    );
  }
}
